import React, { PropTypes } from 'react';
import { Card, Message } from 'semantic-ui-react';
import Transition from 'react-motion-ui-pack';
import { spring, presets } from 'react-motion';
import { compose, defaultProps } from 'recompose';


const { Header, Content } = Card;

const propTypes = {
  title: PropTypes.string,
  error: PropTypes.bool,
  errorIcon: PropTypes.string,
  errorTitle: PropTypes.string,
  errorMessage: PropTypes.string,
  children: PropTypes.any,
};

const AccountsCard = (props) => {
  const style = { textAlign: 'left' };

  return (
    <Transition
      component={false}
      measure={false}
      enter={{
        opacity: 1,
        translateY: spring(0, presets.wobbly),
      }}
      leave={{
        opacity: 0,
        translateY: 500,
      }}
    >
      <Card key="account-card" centered raised style={style}>
        <Content>
          <Header>{props.title}</Header>
        </Content>
        <Content>
          {props.children}
        </Content>
        <Transition
          component={false}
          measure={false}
          enter={{
            opacity: 1,
            height: 68,
          }}
          leave={{
            opacity: 0,
            height: 0,
          }}
        >
          {
            props.error &&
            <div key="errorMessage" style={{ clear: 'both' }}>
              <Message
                visible={props.error}
                error
                attached="bottom"
                icon={props.errorIcon}
                header={props.errorTitle}
                content={props.errorMessage}
              />
            </div>
          }
        </Transition>
      </Card>
    </Transition>
  );
};

AccountsCard.propTypes = propTypes;

const enhance = compose(
  defaultProps({
    error: false,
    errorIcon: 'ban',
    errorTitle: 'Erro',
    errorMessage: '',
  }),
);

export default enhance(AccountsCard);



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/components/shared/accountsCard/AccountsCard.js
 **/